import React, { createContext, useContext, useState } from 'react'
import styled from 'styled-components'
import { InputVariant } from '../system/forms/input'
import FormControl from '../system/forms/form-control'
import EventType, { getEventTypeLabel } from '../../models/event/event-type'
import DateRange from '../system/forms/date-range'
import MultiSelect from '../system/forms/multi-select'
import PACLocation from '../../models/event/pac-location'

export const LocationsContext = createContext<PACLocation[]>([])
export const FiltersContext = createContext({
  state: [],
  clear: () => {},
  hasFilters: false
})

const StyledFormControl = styled(FormControl)`
  label {
    font-weight: 800;
  }
`

const Filters = ({
  isMobile,
  variant,
  ...other
}: {
  isMobile: boolean
  variant: InputVariant
}): JSX.Element => {
  const locations = useContext(LocationsContext)
  const {
    state: [filters, setFilters]
  } = useContext(FiltersContext)
  const [focusedInput, setFocusedInput] = useState(null)

  let canUpdate = false
  setTimeout(() => {
    canUpdate = true
  }, 100)

  return (
    <form onSubmit={e => e.preventDefault()} {...other}>
      <StyledFormControl>
        <label>
          Venue
          <MultiSelect
            inputId="venuesInput"
            instanceId="venues"
            value={filters.venues}
            onChange={venues => setFilters({ ...filters, venues })}
            options={locations.map(location => ({ value: location.id, label: location.name }))}
            variant={variant}
          />
        </label>
      </StyledFormControl>
      <StyledFormControl>
        <label>
          Event Type
          <MultiSelect
            inputId="eventTypesInput"
            instanceId="eventTypes"
            value={filters.eventTypes}
            onChange={eventTypes => setFilters({ ...filters, eventTypes })}
            options={Object.keys(EventType).map(eventTypeName => {
              return {
                value: eventTypeName,
                label: getEventTypeLabel(EventType[eventTypeName])
              }
            })}
            variant={variant}
          />
        </label>
      </StyledFormControl>
      <StyledFormControl>
        <label>
          Date
          <DateRange
            startDate={filters.startDate}
            startDateId={`filters_start_date_${isMobile ? 'mobile' : 'desktop'}`}
            endDate={filters.endDate}
            endDateId={`filters_end_date_${isMobile ? 'mobile' : 'desktop'}`}
            onDatesChange={({ startDate, endDate }) => {
              setFilters({ ...filters, startDate, endDate })
            }}
            focusedInput={focusedInput}
            onFocusChange={focusedInput => {
              if (canUpdate) {
                setFocusedInput(focusedInput)
              }
            }}
            variant={variant}
            isOutsideRange={() => false}
            orientation={isMobile ? 'vertical' : 'horizontal'}
          />
        </label>
      </StyledFormControl>
    </form>
  )
}

export default Filters
